export default __webpack_public_path__ + "static/media/Plus.7cd4c04c.svg";